import { reactive, computed } from 'vue';
import { MODELIMG } from '@/enum/enum';
import Button from '../button/index.vue';


export default {
  name: 'cardinfo',
  components: {
    Button
  },
  props: {
    btn1: {
      type: String,
      default: 'Set Calibration',
      required: false,
    },
    btn2: {
      type: String,
      default: 'Download CSV',
      required: false,
    },
    slotName: {
      type: String,
      default: 'card',
      required: false,
    },
    dataInfo: {
      type: [Object, Array],
      required: false,
      default: {
        groupName: 'groupName',
        modelName: 'PA329CV',
        SerialNumber: 'SN-01234567879',
        PCName: 'AA170057_PC',
        Group: 'OPUE / PCUE / Group Name...',
        AddDate: '2019/12/23',
        IPAddress: '172.16.24.1',
        ConnectionStatus: 'Online',
        // imgUrl: 'https://cdn-images.farfetch-contents.com/15/97/00/39/15970039_29643246_1000.jpg',

      },
    },
  },
  setup(props, { emit }) {

    const { dataInfo } = props;
    const state = reactive({
      // url: dataInfo.imgUrl, //img url
    })

    const setCalibration = () => {
      emit('setCalibration', dataInfo)
    }

    const setUnbind = () => {
      emit('setUnbind', dataInfo)
    }

    const imgPath = computed(() => {
      let name = ''
      for (const key in MODELIMG) {
        if (props.dataInfo.model == key) {
          name = MODELIMG[key]
        }
      }

      return name ? name : MODELIMG['default']

    })

    return {
      state,
      setCalibration,
      setUnbind,
      imgPath
    }
  }// end: setup

}


